/**
 * Koduje "?" na "%3F" w przekazanym ciągu.
 *
 * @param {string} str - string do zakodowania
 * @return {string}
 */
const codeQuestionMark = str => str.replace(/\?/g, '%3F');

export default codeQuestionMark;
